/** Идентификаторы вкладки и её панели: связывают их через `aria-labelledby`. */

/** id кнопки вкладки — для `aria-labelledby` панели. */
export function tabId(idPrefix: string, id: string): string {
  return `${idPrefix}-tab-${id}`
}

/** id панели вкладки — панель рисует вызывающий. */
export function panelId(idPrefix: string, id: string): string {
  return `${idPrefix}-panel-${id}`
}
